module.exports = __webpack_public_path__ + "img/065.47c7842f.png";